import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/paging_arrow_left.png'
import _imports_1 from '@/assets/images/paging_arrow_right.png'
import _imports_2 from '../assets/images/icon-search.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "contents_div" }
const _hoisted_4 = { class: "styled-table" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "search_div" }
const _hoisted_9 = { class: "search_wrap" }

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ApiResponse, ResourceBoards } from "../common/types";
import resourceBoardAPI from "../api/resourceBoardAPI";
import { convertDate } from "../utils/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceBoardView',
  setup(__props) {

const router = useRouter();

// 전체 데이터
const resourceBoardList = ref<ResourceBoards[]>([]);
const searchTitle = ref("");
// 현재 페이지에 보여줄 데이터
const currentPage = ref(1);
const pageSize = ref(5);

// 전체 페이지 수 계산
const totalPages = computed(() => {
  // 데이터가 없으면 0 반환
  if (!resourceBoardList.value || resourceBoardList.value.length === 0) {
    return 0;
  }
  return Math.ceil(resourceBoardList.value.length / pageSize.value);
});

// 현재 페이지 데이터 슬라이싱

const displayedResourceBoards = computed(() => {
  if (!resourceBoardList.value || resourceBoardList.value.length === 0) {
    return []; // 데이터가 없을 때 빈 배열 반환
  }
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return resourceBoardList.value.slice(start, end);
});

// 페이지 번호 목록 계산
const pages = computed(() => {
  const maxPagesToShow = 5;
  const half = Math.floor(maxPagesToShow / 2);
  let start = Math.max(1, currentPage.value - half);
  let end = Math.min(totalPages.value, currentPage.value + half);

  if (currentPage.value <= half) {
    end = Math.min(totalPages.value, maxPagesToShow);
  } else if (currentPage.value + half >= totalPages.value) {
    start = Math.max(1, totalPages.value - maxPagesToShow + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
});

// 데이터 가져오기
const getResourceBoards = async () => {
  const param = searchTitle.value.trim() || ""; // 공백 제거
  try {
    const res = await resourceBoardAPI.getResourceBoards({ title: param });
    resourceBoardList.value = res.data.data; // 전체 데이터 저장
  } catch (error) {
    console.error("Failed to fetch resource boards:", error);
  }
};

// 상세 페이지로 이동
const goDetail = (data: ResourceBoards) => {
  router.push({ name: "resourceBoardDetail", params: { seq: data.자료순번 } });
};

// 페이지 이동 함수
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const goToPage = (page: number) => {
  currentPage.value = page;
};

// 초기 데이터 로드
onMounted(() => {
  getResourceBoards();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "page_header" }, " 자료실 ", -1)),
        _createElementVNode("table", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "구분"),
              _createElementVNode("th", null, "제목"),
              _createElementVNode("th", null, "등록일"),
              _createElementVNode("th", null, "조회수")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedResourceBoards.value, (resourceBoard, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                onClick: ($event: any) => (goDetail(resourceBoard))
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, "자료실", -1)),
                _createElementVNode("td", null, _toDisplayString(resourceBoard.제목), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(convertDate)(resourceBoard.등록일시)), 1),
                _createElementVNode("td", null, _toDisplayString(resourceBoard.조회수), 1)
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "pagination_left_arrow",
            onClick: prevPage,
            src: _imports_0
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              onClick: ($event: any) => (goToPage(page)),
              class: _normalizeClass({ active: page === currentPage.value })
            }, _toDisplayString(page), 11, _hoisted_7))
          }), 128)),
          _createElementVNode("img", {
            class: "pagination_right_arrow",
            onClick: nextPage,
            src: _imports_1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("select", null, [
            _createElementVNode("option", null, "제목")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTitle).value = $event)),
              type: "text",
              onKeyup: _withKeys(getResourceBoards, ["enter"])
            }, null, 544), [
              [_vModelText, searchTitle.value]
            ]),
            _createElementVNode("img", {
              class: "icon_search",
              src: _imports_2,
              onClick: getResourceBoards
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})